import { http } from '@/libs/http';

export interface RefreshTokenResponse {
  access_token: string;
  refresh_token?: string;
  idp_token?: string | null;
  expires_in: number;
  token_type: string;
}

/**
 * Refresh the session using the refresh token from the httpOnly cookie.
 * Each refresh counts as activity and extends the inactivity window.
 * The renewed platform token (and IdP token, when the provider supports it)
 * replace the ones kept in localStorage.
 */
export async function refreshAccessToken(): Promise<RefreshTokenResponse> {
  try {
    const response = await http.post<RefreshTokenResponse>('/auth/tokens/refresh', {});
    if (response.access_token) {
      localStorage.setItem('auth_token', response.access_token);
    }
    if (response.idp_token) {
      localStorage.setItem('idp_token', response.idp_token);
    }
    return response;
  } catch (error) {
    console.error('Token refresh failed:', error);
    throw error;
  }
}
